<template>
  <div class="analytics" :class="{ 'is-loaded': isLoaded }">
    <Loading class="analytics_loading" />
    <v-container class="cards" v-if="sortedScore.length > 0">
      <v-row v-for="n in 1" :key="n" :class="n === 1 ? 'mb-6' : ''">
        <v-col
          v-for="(result, index) in sortedScore"
          :key="index"
          lg="4"
          md="4"
          sm="12"
          cols="12"
        >
          <v-card
            class="pa-10 analytics_card"
            link
            transition="scale-transition"
            v-on:click="toResultPath(score[index]['diagnosisId'])"
          >
            <div v-if="getLanguage == '日本語'">
              <p class="date">
                <span class="date_label">受検日</span>
                <span class="date_day">
                  {{ result["createdAt"].substr(0, 16) }}
                </span>
              </p>
              <div class="score">
                <p class="score_label">総合スコア</p>
                <p class="score_num">
                  {{
                    Math.round(
                      result["sleepQualityCoverted"] +
                        result["sasRiskConverted"] +
                        result["todaiPerformanceConverted"] +
                        result["daytimeSleepinessConverted"] +
                        result["motivationWorkingStyleCoverted"]
                    )
                  }}
                </p>
              </div>
            </div>

            <div v-if="getLanguage == 'English'">
              <p class="date">
                <span class="date_label">Examination date</span>
                <span class="date_day">
                  {{ result["createdAt"].substr(0, 16) }}
                </span>
              </p>
              <div class="score">
                <p class="score_label">Score</p>
                <p class="score_num">
                  {{
                    Math.round(
                      result["sleepQualityCoverted"] +
                        result["sasRiskConverted"] +
                        result["todaiPerformanceConverted"] +
                        result["daytimeSleepinessConverted"] +
                        result["motivationWorkingStyleCoverted"]
                    )
                  }}
                </p>
              </div>
            </div>

            <div v-if="getLanguage == '中文'">
              <p class="date">
                <span class="date_label">作答日期</span>
                <span class="date_day">
                  {{ result["createdAt"].substr(0, 16) }}
                </span>
              </p>
              <div class="score">
                <p class="score_label">分数</p>
                <p class="score_num">
                  {{
                    Math.round(
                      result["sleepQualityCoverted"] +
                        result["sasRiskConverted"] +
                        result["todaiPerformanceConverted"] +
                        result["daytimeSleepinessConverted"] +
                        result["motivationWorkingStyleCoverted"]
                    )
                  }}
                </p>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="analytics_zero" v-if="sortedScore.length == 0">
      <div v-if="getLanguage == '日本語'">
        <p class="analytics_zeroTxt">診断結果がまだありません。</p>
      </div>
      <div v-if="getLanguage == 'English'">
        <p class="analytics_zeroTxt">No diagnostic results yet</p>
      </div>
      <div v-if="getLanguage == '中文'">
        <p class="analytics_zeroTxt">尚无诊断</p>
      </div>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import { Auth } from "aws-amplify";
import Loading from "../components/Loading";

const gradients = [["#f72047", "#ffd200", "#1feaea"]];

export default {
  name: "Analytics",
  // eslint-disable-next-line
  beforeRouteEnter(to, from, next) {
    switch (from["path"]) {
      case "/":
        next({ path: "/mytop" });
        break;
      default:
        next();
    }
  },
  created() {
    axios
      .get("/results/diagnoses", {
        params: {
          userName: this.getLoginUserId,
        },
        headers: { Authorization: this.getAccessToken },
        data: {},
      })
      .then((response) => {
        this.score = response.data;
        for (const idx in this.score) {
          this.value.push(
            this.score[idx]["sleepQualityCoverted"] +
              this.score[idx]["sasRiskConverted"] +
              this.score[idx]["todaiPerformanceConverted"] +
              this.score[idx]["daytimeSleepinessConverted"] +
              this.score[idx]["motivationWorkingStyleCoverted"]
          );
          this.labels.push(this.score[idx]["completedAt"]);
        }
        this.isLoaded = true;
      })
      .catch((err) => {
        (this.errored = true), (this.error = err);
      });
  },
  data() {
    return {
      isLoaded: false,
      score: [],
      fill: true,
      gradient: gradients[5],
      gradients,
      color: "white",
      padding: 20,
      radius: 10,
      value: [],
      labels: [],
      width: 1,
    };
  },
  beforeCreate() {
    Auth.currentAuthenticatedUser().then((user) => {
      this.user = user;
    });
  },
  methods: {
    toResultPath(diagnosisId) {
      this.$router.push({
        name: "result",
        params: { diagnosisId: diagnosisId, from: "analytics" },
      });
    },
    isLoadedFunc() {
      this.isLoaded = true;
    },
  },
  computed: {
    ...mapGetters([
      "getLoginState",
      "getLoginUserId",
      "getAccessToken",
      "getLanguage",
    ]),
    sortedScore: function () {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.score.reverse();
    },
  },
  components: {
    Loading,
  },
};
</script>
<style lang="scss" scoped>
.analytics {
  background-color: #5592c6;
  overflow: hidden;
  height: calc(100vh - 110px);
  &_loading {
    position: fixed;
    z-index: 99999;
    top: 0;
    left: 0;
  }
  &.is-loaded {
    overflow: auto;
  }
  &.is-loaded &_loading {
    opacity: 0;
    transition: opacity 1s ease;
    pointer-events: none;
  }
  &_card {
    text-align: center;
  }
  &_zero {
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100vh - 114px);
  }
  &_zeroTxt {
    color: #fff;
    font-size: 28px;
    letter-spacing: 0.05em;
    padding: 42px 20px 42px 42px;
    background: #004d76;
    border-radius: 4px;
  }
}
.date {
  &_label {
    display: inline-block;
    vertical-align: middle;
    color: #808080;
    font-size: 14px;
  }
  &_day {
    display: inline-block;
    vertical-align: middle;
    color: #808080;
    font-size: 14px;
    margin-left: 4px;
  }
}
.score {
  color: #1d64a1;
  &_label {
    line-height: 1;
    padding: 4px 8px;
    border-radius: 16px;
    display: inline-block;
    background-color: #1d64a1;
    color: #fff;
    font-size: 14px;
  }
  &_num {
    font-size: 72px;
    font-weight: bold;
    line-height: 1;
  }
}
</style>
